import { render, staticRenderFns } from "./ProductInfoDialog.vue?vue&type=template&id=712c8f9e&scoped=true"
import script from "./ProductInfoDialog.vue?vue&type=script&lang=js"
export * from "./ProductInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoDialog.vue?vue&type=style&index=0&id=712c8f9e&prod&scoped=true&lang=css"
import style1 from "./ProductInfoDialog.vue?vue&type=style&index=1&id=712c8f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c8f9e",
  null
  
)

export default component.exports